import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import VolumeDemo from './components/VolumeDemo';
import Guide from './components/Guide';
import Recommendations from './components/Recommendations';
import Faq from './components/Faq';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href="#hero"
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
      }`}
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </a>
  );
}

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <VolumeDemo />
        <Guide />
        <Recommendations />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}